import React, { useState, useContext, useRef } from 'react';
import Modal from "react-modal";
import { IoMdClose } from 'react-icons/io';
import { Tooltip } from "react-tooltip"
import { AiOutlineInfoCircle } from 'react-icons/ai';




const LinkSetGtin = ({ data}: { data: any }) => {
  
  

  return (
    <>


      <div className=''>
        <div className=' linktitle' style={{ marginBottom:'0px'}}>
          <h4  style={{ marginBottom:'0px', fontSize:'26px'}}>Links para informações dos produtos</h4>
        </div>
        <div>
          {data.map((item:any) => (
          <>
            {item  && ( 
                         <div className='linkItem'>
                         <h5 style={{fontSize:'20px'}}>{item.name}<AiOutlineInfoCircle  style={{marginLeft:"18px"}} className={item.name?.replace(/\s+/g, '') || ''} /></h5>
                         
                           <Tooltip anchorSelect={"."+(item.name?.replace(/\s+/g, '') || '')} place="right">
                             <span style={{wordWrap:"break-word", maxWidth:"100px"}}>{item.tooltip}</span>
                           </Tooltip>
                       </div>
                    ) }
            {item && (
              <>
              <div>
                <span className="linkblue"><a href={item.href} target="_blank">{item.title+" "}</a></span>
                <span className="linkred">{item.type}</span>
              </div>
              <div className='languageLink'>Idioma:{Array.isArray(item.lang) ? item.lang.join(', ') : item.lang}</div>
              </>
            )}
            
          </> 
          ))}
        </div>

      </div>
      
    </>
  );
};

export default LinkSetGtin;
